var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142.7 171.5",
    style: {
      enableBackground: "new 0 0 142.7 171.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005EA9;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#EA3326;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,87.2L56.2,71.2V165c8.9,4.3,15.1,6.6,15.1,6.6s6.2-2.3,15.1-6.5V71.2C86.4,71.2,71.3,87.2,71.3,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,11.4V112c0,1.7,0.3,3.3,0.9,4.8c5.3,12.6,16.1,23.3,27.7,31.8V41.8L0,11.4L0,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.7,11.4l-28.5,29.4v107.8c11.6-8.5,22.4-19.1,27.6-31.7c0.6-1.5,0.9-3.2,0.9-4.8L142.7,11.4L142.7,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,41.8v106.8c9.6,7,19.6,12.5,27.6,16.4V71.2C56.2,71.2,28.6,41.8,28.6,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,71.2V165c8-3.9,18.1-9.4,27.7-16.4V41.7L86.4,71.2L86.4,71.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0l71.3,75.8L142.7,0H0L0,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.5,52.5 68.3,39.8 53.3,44.7 62.6,32 53.3,19.2 68.3,24.1 77.5,11.4 77.5,27.1 92.5,32 77.5,36.8  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatys);
export default __webpack_public_path__ + "static/media/datys.ea9d3fa9.svg";
export { ForwardRef as ReactComponent };